import { combineReducers, } from 'redux';

const config = (state = {},) => state;

const theme = (state = {}, action: any,) => (action.type === 'CHANGE_THEME' ? { ...state, ...action.data, } : state);

export default combineReducers({
  config,
  theme,
},);
